import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    data: {},
    read: {}
  },
  mutations: {
    set (state, payload) {
      state.data = payload
    },
    setRead (state, payload) {
      state.read = payload
    }
  },
  actions: {
    fetch ({ rootState, getters, commit }) {
      apiService.getGoodNews(rootState.seo.client.domains.selected)
        .then(response => {
          commit('set', response.data)

          if (getters.hasProjects) {
            $(`#${window.vue.$getConst('SEO_GOOD_NEWS_MODAL_ID')}`).modal('show')
          }
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию о хороших новостях.'
          })
        })
    },
    fetchRead ({ rootState, commit }) {
      apiService.getGoodNewsRead(rootState.seo.client.domains.selected)
        .then(response => {
          commit('setRead', response.data)

          window.vue.$emit('goodNewsReadLoaded')
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию прочтения хороших новостей.'
          })
        })
    },
    updateRead ({ rootState, state }, domain) {
      apiService.updateGoodNewsRead(
        rootState.seo.client.domains.selected,
        Object.keys(state.data)
      )
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось пометить хорошие новости как прочитанные.'
          })
        })
    }
  },
  getters: {
    forecastProjects: (state, getters, rootState) => {
      const projects = {}

      for (const project of rootState.seo.client.projects.projects) {
        const forecast = state.data.forecast ? state.data.forecast[project.id_parent] : null

        if (!forecast) {
          continue
        }

        project.forecast = forecast

        if (!Object.keys(projects).includes(project.region)) {
          projects[project.region] = {}
        }

        projects[project.region][project.type] = project
      }

      return projects
    },
    hasForecastProjects: (state, getters) => {
      return !!Object.keys(getters.forecastProjects).length
    },
    queriesProjects: (state, getters, rootState) => {
      const projects = {}

      for (const project of rootState.seo.client.projects.projects) {
        const queries = state.data.queries ? state.data.queries[project.id_parent] : null

        if (!queries) {
          continue
        }

        project.queries = queries

        if (!Object.keys(projects).includes(project.region)) {
          projects[project.region] = {}
        }

        projects[project.region][project.type] = project
      }

      return projects
    },
    hasQueriesProjects: (state, getters) => {
      return !!Object.keys(getters.queriesProjects).length
    },
    hasProjects: (state, getters) => {
      return getters.hasForecastProjects || getters.hasQueriesProjects
    }
  }
}
